import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Card from "../components/Card";
import BackToTopButton from "../components/BackToTopButton";

const UserList = () => {
  const [listData, setListData] = useState([]);

  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    let moviesId = window.localStorage.movies ? window.localStorage.movies.split(",") : [];

    for (let i = 0; i < moviesId.length; i++) {
      axios
        .get(`https://api.themoviedb.org/3/movie/${moviesId[i]}?api_key=${API_KEY}&language=fr-FR`)
        .then((res) => setListData((listData) => [...listData, res.data]));
    }
  }, [API_KEY]);

  return (
    <div className="user-list-page">
      <Header />
      <h2>
        Coup(s) de coeur <span>💖</span>
      </h2>
      <div className="result">
        {listData.length > 0 ? (
          listData.map((movie) => <Card movie={movie} key={movie.id} />)
        ) : (
          <h2>Aucun coup de coeur pour le moment</h2>
        )}
      </div>
      <BackToTopButton />
    </div>
  );
};

export default UserList;
